import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";

import { deleteAccountData } from "src/apiService/modules/system";
import {
  isImpersonationSessionSelector,
  userRoleSelector,
} from "src/store/system/selector";
import ConfirmDeleteAccountDataDialog from "./ConfirmDeleteAccountDataDialog";
import { useRecordEvent } from "src/hooks/useRecordEvent";

const useStyles = makeStyles((theme) => ({
  errorButton: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.error.dark,
    },
  },
}));

function RestartButton() {
  const recordEvent = useRecordEvent();

  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const userRole = useSelector(userRoleSelector);
  const isImpersonation = useSelector(isImpersonationSessionSelector);
  // Owner-only action: support viewers and any impersonation session (accountant
  // / support staff) must not wipe the reseller's data.
  const deleteDisabled = userRole === "viewer" || isImpersonation;

  return (
    <>
      <ConfirmDeleteAccountDataDialog
        open={open}
        onCancel={() => setOpen(false)}
        onConfirm={async () => {
          try {
            await deleteAccountData();
            recordEvent({
              type: "feature-adoption",
              feature: "delete-all-data",
            });
            toast.success("Data deleted successfully");
          } catch (e) {
            toast.error(
              `Error: ${(e as Error).message || (e as Error).toString()}`
            );
          }
          setOpen(false);
        }}
      />
      <Typography component="p" variant="subtitle1" align="center">
        Need to restart? No problem, click the “Delete Account Data” button
        below.
      </Typography>
      <Box display="flex" width="100%" justifyContent="center" my={2}>
        <Button
          variant="contained"
          className={classes.errorButton}
          onClick={() => setOpen(true)}
          disabled={deleteDisabled}
        >
          Delete Account Data
        </Button>
      </Box>
    </>
  );
}

export default RestartButton;
